import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ourServicesContent from "../ourServices/ourServicesContent";
import "../../styles/footer/style.scss";

const FooterComponent = ({ handleScrollToPortion, ref }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="footer-wrapper" ref={ref}>
        <div className="footer-content-wrapper">
          <div className="wizzgeeks-content-wrapper width-20">
            <div className="content-heading">Wizzgeeks</div>
            <div className="content-details">
              Expert Solutions, Trusted Partner.
            </div>
            <div className="media-image-wrapper">
              <a
                href="https://in.linkedin.com/company/wizzgeeks"
                target="_blank"
              >
                <img src="/images/footer/linkinImage.svg" alt="linkin" />
              </a>
            </div>
          </div>
          <div className="services-content-wrapper width-40">
            <div className="content-sub-heading">Services</div>
            <div className="content-wrapper">
              <div className="content-details-wrapper width-50">
                {ourServicesContent.ourServices?.slice(0, 5).map((service) => (
                  <a
                    className="content-details"
                    href={`/services/${service.name}`}
                    key={service.name}
                  >
                    {service.name}
                  </a>
                ))}
              </div>
              <div className="content-details-wrapper width-50">
                {ourServicesContent.ourServices?.slice(5, 10).map((service) => (
                  <a
                    className="content-details"
                    href={`/services/${service.name}`}
                    key={service.name}
                  >
                    {service.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="services-content-wrapper width-20">
            <div className="content-sub-heading">Company</div>
            <div className="content-details-wrapper">
              <a className="content-details" href={`/aboutUs`}>
                About Us
              </a>
              <a
                className="content-details"
                onClick={() => {
                  navigate("/", { state: { scrollTo: "Case Studies" } });
                }}
              >
                Case Studies
              </a>
              <a className="content-details" href={`/blog`}>
                Blog
              </a>
              <a
                className="content-details"
                onClick={() => {
                  handleScrollToPortion("Contact");
                }}
              >
                Contact
              </a>
            </div>
          </div>
          <div className="services-content-wrapper width-20">
            <div className="content-sub-heading">Contact</div>
            <div className="content-details-wrapper">
              <div className="content-details image-with-data">
                <img
                  src="../../images/footer/location.svg"
                  alt="location"
                ></img>
                KSSIDC Complex, 1st Block, 216, Indra Nagar, Electronics City
                Phase 1, Electronic City, Bengaluru, Karnataka 560100
              </div>
              {/* <div className="content-details image-with-data">
                <img src="../../images/footer/mobile.svg" alt="mobile"></img>+1
                (555) 123-4567
              </div> */}
              <div className="content-details image-with-data">
                <img src="../../images/footer/mail.svg" alt="email"></img>
                contact@wizzgeeks.com
              </div>
            </div>
          </div>
        </div>
        <div className="footer-border"></div>
        <div className="footer-term-and-policy-wrapper">
          <div className="rights-content">
            © 2025 Wizzgeeks. All rights reserved.
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterComponent;
